<template>
<section class="fixed-top" style="background: #16236E;">
    <div class="container">
        <div class="d-flex justify-content-between align-items-center">
            <div class="brand d-flex align-items-center">
                <a class="navbar-brand border-right mb-0" href="https://ventas.serpar.gob.pe">
                    <img :src="'/static/logos/serpar-white.png'" width="auto" height="90" alt="SERPAR LIMA">
                </a>
                <h3 class="title-header mb-0" v-text="title"></h3>
            </div>
            <div class="d-none d-md-block">
                <span class="m-0 text-white">Síguenos en</span>
                <ul class="redes-sociales d-flex">
                    <li class="mr-2">
                        <a href="https://www.facebook.com/limaserpar" target="_blank">
                            <img :src="url + '/wp-content/uploads/2019/02/fb_50x50.png'" width="30px"></a>
                    </li>
                    <li class="mr-2">
                        <a href="https://www.instagram.com/limaserpar" target="_blank">
                            <img :src="url + '/wp-content/uploads/2019/02/in_50x50.png'" width="30px"></a>
                    </li>
                    <li class="mr-2">
                        <a href="https://www.tiktok.com/@limaserpar" target="_blank">
                            <img :src="url + '/wp-content/uploads/2022/12/tik-tok-1.png'" width="30px"></a>
                    </li>
                    <li class="mr-2">
                        <a href="https://www.linkedin.com/company/limaserpar/" target="_blank">
                            <img :src="url + '/wp-content/uploads/2022/12/linkedin-1.png'" width="30px"></a>
                    </li>
                    <li>
                        <a href="https://www.twitter.com/limaserpar" target="_blank">
                            <img :src="url + '/wp-content/uploads/2019/02/tw_50x50.png'" width="30px"></a>
                    </li>
                </ul>
            </div>

        </div>

    </div>
    <div class="row">
        <div class="col-sm-4" style="background:#EECC00; height:5px"></div>
        <div class="col-sm-4" style="background:#EECC00;"></div>
        <div class="col-sm-4" style="background:#EECC00;"></div>
    </div>

    <!--<div class="container">

        <div class="row align-items-center justify-content-center">
            <div class="col-md-9 col-lg-7">
                <div class="page-header-content text-white text-center pt-sm-5 pt-md-5 pt-lg-0">
                    <h1 class="text-white mb-0" v-text="title"></h1>
                    <div class="custom-breadcrumb">
                        <ol class="breadcrumb d-inline-block bg-transparent list-inline py-0">
                            <li class="list-inline-item breadcrumb-item"><a href="#" v-text="subtitle"></a></li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>-->
</section>
<!--<section v-else class="hero-section ptb-100" style="background: rgb(0, 163, 156);">
    <div class="container">
        <div class="row align-items-center justify-content-center">
            <div class="col-md-9 col-lg-7">
                <div class="page-header-content text-white text-center pt-sm-5 pt-md-5 pt-lg-0">
                    <h1 class="text-white mb-0" v-text="title"></h1>
                    <div class="custom-breadcrumb">
                        <ol class="breadcrumb d-inline-block bg-transparent list-inline py-0">
                            <li class="list-inline-item breadcrumb-item"><a href="#" v-text="subtitle"></a></li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>-->
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
            default: "",
        },
        subtitle: {
            type: String,
            required: true,
            default: ""
        },
        img_header: {
            type: String,
            required: false,
            default: ""
        }
    },
    data: () => ({
        url: ''
    }),
    created() {
        this.url = process.env.API7;
    }
}
</script>
<!--style="background:#00A39C"-->



// WEBPACK FOOTER //
// src/components/common/subHeader.vue